import { ChangeEvent, useState } from 'react'

const FORBIDDEN_CHARS = /[<>{}[\]\\]/g

// кириллица, латиница, цифры, пробел, тире, точка, запятая, нижнее подчёркивание, скобки, ! и ?
export const DISPLAY_NAME_PATTERN = /[^а-яёА-ЯЁa-zA-Z0-9 \-.,_()!?]/g

interface UseInputSanitizeOptions {
  maxLength?: number
  trim?: boolean
  allowPattern?: RegExp
}

export const useInputSanitize = (initialValue: string, options: UseInputSanitizeOptions = {}) => {
  const { maxLength = 100, trim = true, allowPattern } = options
  const [value, setValue] = useState(initialValue)

  const onChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const raw = allowPattern ? e.target.value.replace(allowPattern, '') : e.target.value.replace(FORBIDDEN_CHARS, '')
    const clamped = maxLength ? raw.slice(0, maxLength) : raw
    setValue(clamped)
  }

  const onBlur = () => {
    if (trim) setValue((v) => v.trim())
  }

  const reset = () => setValue(initialValue)

  return { value, setValue, onChange, onBlur, reset }
}
